import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { selectors as coreSelectors } from 'mage-core';
import { selectors as configSelectors } from 'mage-config';

import { selectQueryFromLocation } from '@/selectors/widget';
import { getRegionConfig, getCountryConfig as getAllCountryConfig } from '@/selectors/options';

export const getLocationQueryParam = paramName =>
  createSelector(selectQueryFromLocation, query => _get(query, paramName));

export const getBackendFullUrlByRegion = createSelector(
  coreSelectors.generateGetBackendUrlForRegion,
  configSelectors.getMerchantPortalBaseUrl,
  (getBackendUrlForRegion, merchantPortalBaseUrl) => region => {
    // MPP base URL for current region is always an empty string but we need the full URL
    // so we default to window.location.origin
    const baseUrl =
      process.env.NODE_ENV === 'development' ? window.location.origin : merchantPortalBaseUrl;
    // has leading and trailing slashes
    const backendPath = getBackendUrlForRegion({ backendName: 'products', region });
    return `${baseUrl}${backendPath}`;
  },
);

export const getCountryConfig = (country, region) =>
  createSelector(getRegionConfig, getAllCountryConfig, (regionConfig = {}, countryConfig = {}) => ({
    ...(regionConfig[region] || {}),
    ...(countryConfig[country] || { isDefault: true }),
  }));
